/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from "react";
import { Button } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useRouter } from "next/navigation";


function HomeFeaturedBrands1({ brands = [] }: { brands?: any[] }) {
  const router = useRouter();
  type Slider = any;
  const sliderRef = useRef<Slider | null>(null);
  const settings2 = {
    infinite: brands.length > 7,
    slidesToShow: 7,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1800,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: brands.length > 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          infinite: brands.length > 2,
        },
      },
    ],
  };

  return (
    <>
      <section className="home_brands1_sc product_sc">
        <div className="container">
          <div className="s_head flex hd_4">
            <div className="lt">
              <h2>Featured Brands</h2>
              <p>Handpicked for You, Trusted by All</p>
            </div>
            <div className="rt">
              <Button
                variant="outlined"
                size="small"
                onClick={() => router.push("/product/product-category")}
              >
                More <KeyboardArrowRightIcon />
              </Button>
            </div>
          </div>

          <Slider ref={sliderRef} {...settings2} className="brand_slider1">
            {brands.map((brand, index) => (
              <div
                key={`home-featured-brand-1-${brand.id || brand.brand_id || 'no-id'}-${index}`}
                className="brand_item1"
                onClick={() => {
                  if (brand.type === "brand") {
                    router.push(`/product/product-category?brand_id=${brand.id}&type=featured_brands`);
                  } else if (brand.type === "category") {
                    router.push(`/product/product-category?category_id=${brand.id}&type=featured_brands`);
                  } else {
                    router.push("/product/product-category?type=featured_brands");
                  }
                }}
                style={{ cursor: 'pointer' }}
              >
                {brand.logo && (
                  <figure className="brand_logo">
                    <img src={brand.logo} alt="Logo" />
                  </figure>
                )}
                <figure className="brand_img" style={{ flex: 1, overflow: 'hidden', borderRadius: '15px' }}>
                  <img src={brand.image} alt="Brand Image" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                </figure>
              </div>
            ))}
          </Slider>
          <div className="mblvw_btn">
            <Button
              variant="outlined"
              size="small"
              onClick={() => router.push("/product/product-category")}
            >
              View All <KeyboardArrowRightIcon />
            </Button>
          </div>
        </div>
      </section>
    </>
  );
}

export default HomeFeaturedBrands1;
